import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { }

  trigger() {
    $(this.element).slideUp().next().delay(100).slideDown()
  }
}
